module.exports = __webpack_public_path__ + "static/media/icon-post-list-off.d1165a56.svg";